angular.module('rightPaneModule')
	.controller('StudentOverviewController', [
        'translateFilter',
        '$scope',
        '$state',
        'moment',
        'authentication',
        'configuration',
        'customer',
        'edxReportItemService',
        'timeframe',
        'studentApi',
        'edxDateTimeService',
    function(
        translateFilter,
        $scope,
        $state,
        $moment,
        authentication,
        configuration,
        customer,
        edxReportItemService,
        timeframe,
        studentApi,
        dateTimeService
    ) {
        $scope.years = { list: null, selected: {} };
        $scope.timeframes = {
            list: [
                { id: '1d', name: translateFilter('shared.timeframes.today'), by: 'day', active: false },
                { id: '0w', name: translateFilter('shared.timeframes.thisWeek'), by: 'day', active: true },
                { id: '7d', name: translateFilter('shared.timeframes.last7Days'), by: 'day', active: false },
                { id: '30d', name: translateFilter('shared.timeframes.last30Days'), by: 'week', active: false }
            ],
            selected: {}
        };

        // Simple and temporary way to notify subcomponents of a timeframe change.
        // TODO: look at observable lib like rxjs.
        $scope.timeframeChange = 0;

        var timeframeChanged = function() {
            $scope.studentOverviewExportUrl = studentApi.getStudentsReportingForStudentExportUrl();

            $scope.timeframeChange++;
        };

        $scope.isTodaySelected = function() {
          return $scope.timeframes.selected.id === '1d';
        };

        $scope.todayDate = function() {
          return new Date();
        };

        $scope.todayDayOfTheWeek = function() {
          return dateTimeService.dayOfWeekOrToday(new Date());
        };

        var initializeData = function(item) {
            // Using $scope.student here instead of $scope.item, because $scope.item is
            // set by a higher controller and may refer to the classroom or another
            // student before this initialization is called.
            // Doing clone here to prevent districtId on $scope.student from being erased by cached resource
            // after it is set (IN-2487 rbox when renavigating to a student overview)
            $scope.student = _.cloneDeep(item);
            $scope.student.districtId = $state.params.districtId;
        };

        var authCustomer = authentication.getCustomer();

        $scope.options = {
            canAssignLessons: authentication.canAssignLessons(authCustomer),
            efpEnabled: authCustomer.hasTag('INSIGHT_EFP'),
            hideStudentPlacement: !configuration.isFeatureEnabled('student_proficiency_grid_placement_enabled'),
            loadDemoLessons: true,
            loadStandards: true,
            viewMode: authentication.growthAsFraction() ? 'fractionMode' : 'percentMode'
        };

        $scope.astName = customer.getAcademicStandard().academic_standard_name;

        var timeframeSubscription = timeframe.getYearListSubject().subscribe(function (years) {
            $scope.years.list = angular.copy(years);
        });

        var itemSubscription = edxReportItemService.getCurrentItemObservable().subscribe(initializeData);
        $scope.$on('timeframeSelected', timeframeChanged);
        $scope.$on('timeframeInitialized', timeframeChanged);

        $scope.$on('$destroy', function () {
            itemSubscription.dispose();
            timeframeSubscription.dispose();
        });
    }
]);
